export const actorTypes = {
  SYSTEM: "SYSTEM",
};

export const actorTypeKeys = {
  SYSTEM: "systemString",
};
